import { MdDelete } from "react-icons/md";
import BackButton from "./BackButton";
import Colors from "../../constants/Colors";
import { FiSave } from "react-icons/fi";

interface BottomModalProps {
  onBack?: () => void;
  id?: string | number | null;
  onDelete?: () => void;
  onSave?: () => void;
  style?: string | React.CSSProperties;
  type?: "button" | "submit" | "reset";
}

function BottomModal({
  onBack,
  id,
  onDelete,
  onSave,
  style,
  type = "button",
}: BottomModalProps) {
  return (
    <div
      className={`mt-4 sm:mt-8 grid gap-3 sm:gap-2 lg:flex lg:flex-row-reverse lg:justify-between w-full pb-2 sm:pb-4 ${
        typeof style === "string" ? style : ""
      }`}
      style={typeof style === "object" ? style : undefined}
    >
      <div className="w-full flex flex-col sm:flex-row justify-end gap-3 sm:gap-4">
        <BackButton
          className="w-full sm:w-auto lg:w-1/3"
          title="Cancelar"
          onBack={onBack}
        />

        <button
          type={type}
          onClick={onSave}
          className="justify-center w-full sm:w-auto lg:w-1/3 flex py-3 sm:py-4 px-4 rounded-2xl sm:rounded-3xl text-sm sm:text-base font-bold italic bg-[#6253D4] text-white hover:bg-opacity-90 transition dark:hover:bg-opacity-80"
        >
          <div className="flex items-center gap-2">
            <FiSave size={18} className="sm:w-5 sm:h-5" /> Salvar
          </div>
        </button>
      </div>

      {id !== null && onDelete ? (
        <div className="mb-4 sm:mb-6 mt-0 sm:mt-2 lg:mt-0 lg:mb-0 w-full lg:w-1/5 order-first lg:order-last">
          <BackButton
            className="w-full bg-danger sm:mr-10"
            title="Apagar"
            onClick={() => onDelete()}
            icon={<MdDelete size={18} className="sm:w-5 sm:h-5" />}
            background={Colors.danger}
          />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

export default BottomModal;
